var exports = {
  "kL": "x936d19a0--60e736--container",
  "HU": "x936d19a0--60e736--aside",
  "iW": "x936d19a0--60e736--main",
  "wx": "x936d19a0--60e736--header",
  "Qs": "x936d19a0--60e736--content",
};

module.exports = exports;
